import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "assets";
import SectionControl from "pages/Profile/components/SectionControl";
import ProfileCard from "pages/Profile/components/ProfileCard";
import ProfileButton from "pages/Profile/components/ProfileButton";
import GalleryImageButton from "pages/Profile/components/GalerySection/GaleryImageButton";

interface Props {
  isHeadExpanded?: boolean;
  toggleHeadExpanded: () => void;
  isEdit?: boolean;
}

const Gallery = ({ isHeadExpanded, toggleHeadExpanded, isEdit }: Props) => {
  return (
    <div className="relative grid gap-6">
      <SectionControl
        isExpanded={isHeadExpanded}
        toggleClick={toggleHeadExpanded}
        fullScreenClick={() => undefined}
      />
      <ProfileCard className="aspect-[3/4] min-w-0" isEdit={isEdit} editBottom>
        <ProfileButton className="absolute left-3 top-1/2 rounded-full">
          <ChevronLeftIcon />
        </ProfileButton>
        <ProfileButton className="absolute right-3 top-1/2 rounded-full">
          <ChevronRightIcon />
        </ProfileButton>
      </ProfileCard>
      {isHeadExpanded && (
        <div className="hidden grid-cols-7 gap-2 lg:grid">
          <GalleryImageButton isSelected />
          <GalleryImageButton />
          <GalleryImageButton />
          <GalleryImageButton />
          <GalleryImageButton />
        </div>
      )}
    </div>
  );
};

export default Gallery;
